import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Media, UncontrolledTooltip } from "reactstrap";

import "./SingleItem.scss";

import ProfilePicture from "../../../../Common/ProfilePicture";
import { convertSlaTime } from "../../../../../Libs/CustomMethods/customMethods";

const QueueAttendanceItem = ({
  id,
  isActive,
  onClick,
  image,
  from,
  name,
  description,
  status,
  isClosed,
  statusTooltip = '',
  conversation: chat,
  time,
  rawTime,
}) => {
  const { t } = useTranslation();

  const descriptionObject = {
    telefone: t("Telephone"),
    real_automation: t("Tickets"),
  };

  const timeF = useMemo(()=> {
    if (chat.channel === 'real_automation') {
      if (rawTime) convertSlaTime(rawTime, { fixingSeconds: true })
    }

    if (time === -1) return; 

    return convertSlaTime(time, { fixingSeconds: true }) || '-';
  }, [time, chat, rawTime]);

  return (
    <>
      <li
        id={id}
        className={`queueSingleItem p-3 rounded ${isActive} ${isClosed ? "closedItem" : ""}`}
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <Media>
          <div className="align-self-center photo-feeling-area mr-3">
            <div className="d-flex">
              <ProfilePicture
                name={name}
                src={image}
                dNone={"d-none"}
                sizePx={32}
              />
            </div>
          </div>
          <div className="align-self-center d-flex mr-2">
            <img
              src={from}
              className="rounded-access-origin align-self-start"
              alt=""
            />
          </div>
          <Media className="overflow-hidden mr-3" body>
            <div>
              <h5 className="text-truncate font-size-14 mb-1">
                {name}
                {chat.fromReopen && (
                  <>
                    <i
                      id={`reopen-tooltip-${id}`}
                      class="fas fa-reply-all fa-sm ml-1"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`reopen-tooltip-${id}`}
                    >
                      {t("Conversation started from reopening")}
                    </UncontrolledTooltip>
                  </>
                )}
              </h5>
            </div>
            <p className="text-truncate mb-0">
              {descriptionObject[chat.channel] || description}
            </p>
          </Media>
          <div className="align-self-center text-center mx-0 px-0" id={`status-tooltip-${id}`}>
            <div className="status-icon text-center w-100">
              {status && status.icon}
            </div>
            <div
              className={"font-size-11 mt-1 text-center"}
              style={status && { color: status.color }}
            >
              {timeF}
            </div>
              {statusTooltip && (
                <UncontrolledTooltip placement="top" target={`status-tooltip-${id}`}>
                  {t(`${statusTooltip}`)}
                </UncontrolledTooltip>
              )}
          </div>
        </Media>
      </li>{" "}
      <hr className="my-0" />
    </>
  );
};
export default QueueAttendanceItem;
